import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "./Icon";
import { Heading } from "./Heading";
import { Text } from "./Text";
import { Stack } from "./Stack";
export function EmptyState({ icon, iconLabel, title, body, action, imageSrc, imageAlt, }) {
    return (_jsxs(Stack, { align: "center", justify: "center", gap: "md", style: {
            textAlign: "center",
            padding: "var(--hydrax-space-2xl) var(--hydrax-space-xl)",
            color: "var(--hydrax-color-text-muted)",
        }, children: [imageSrc ? (_jsx("img", { src: imageSrc, alt: imageAlt ?? "", style: {
                    maxWidth: 320,
                    width: "100%",
                    height: "auto",
                    opacity: 0.85,
                    borderRadius: "var(--hydrax-radius-md)",
                } })) : (_jsx("div", { style: {
                    width: 48,
                    height: 48,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "var(--hydrax-radius-lg)",
                    background: "var(--hydrax-color-bg-raised)",
                    border: "1px solid var(--hydrax-color-border)",
                }, children: _jsx(Icon, { icon: icon, label: iconLabel, size: 20 }) })), _jsx(Heading, { level: "h2", as: "h2", children: title }), body ? _jsx(Text, { tone: "muted", children: body }) : null, action ? _jsx("div", { style: { marginTop: "var(--hydrax-space-sm)" }, children: action }) : null] }));
}
//# sourceMappingURL=EmptyState.js.map